import { IconType } from "@/type/icon_type";
import React from "react";

const IconRightArrow = (props: IconType) => {
  const { color, width, height, style } = props;

  return (
    <svg
      width={width || "20"}
      height={height || "18"}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M20 9.00027C19.9999 9.33176 19.8682 9.64965 19.6337 9.88402L12.1337 17.384C11.898 17.6117 11.5822 17.7377 11.2545 17.7349C10.9268 17.732 10.6132 17.6006 10.3815 17.3688C10.1497 17.137 10.0183 16.8235 10.0154 16.4958C10.0126 16.168 10.1386 15.8523 10.3662 15.6165L15.7325 10.2503H1.25C0.918478 10.2503 0.600534 10.1186 0.366114 9.88415C0.131693 9.64973 -1.90735e-06 9.33179 -1.90735e-06 9.00027C-1.90735e-06 8.66875 0.131693 8.3508 0.366114 8.11638C0.600534 7.88196 0.918478 7.75027 1.25 7.75027H15.7325L10.3662 2.38402C10.1386 2.14826 10.0126 1.83251 10.0154 1.50476C10.0183 1.17702 10.1497 0.863502 10.3815 0.631742C10.6132 0.399982 10.9268 0.26852 11.2545 0.265672C11.5822 0.262824 11.898 0.388818 12.1337 0.616515L19.6337 8.11652C19.8682 8.35088 19.9999 8.66877 20 9.00027Z"
        fill={color || "#1373E0"}
      />
    </svg>
  );
};

export default IconRightArrow;
